<div id="capture_detail_header" [ngClass]="{ collapse: isHidden }">
  <div class="row mx-0">
    <div class="col-6 px-0 text-start">
      <nav class="nav nav-pills">
        <a
          class="nav-item nav-link"
          routerLink="/capture-admin/captures/{{capture.id}}"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >
          Capture Details
        </a>
        @if (canViewHistory) {
          <a
            class="nav-item nav-link"
            routerLink="/capture-admin/captures/{{capture.id}}/history-new"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            >
            Capture History (New)
          </a>
        }
        @if (canViewHistory) {
          <a
            class="nav-item nav-link"
            routerLink="/capture-admin/captures/{{capture.id}}/history"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            >
            Capture History (Historical)
          </a>
        }
        @if (canViewFax) {
          <a
            class="nav-item nav-link"
            routerLink="/capture-admin/captures/{{capture.id}}/fax"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            >
            Fax
          </a>
        }
      </nav>
    </div>

    <div class="col-6 px-0 text-end">
      <div class="my-1 d-inline-block">
        <app-user-presence category="capture" [targetId]="capture.id" />
      </div>
      <div class="invoice-credit">
        <span>
          <strong>Audited:</strong>
          @if (capture.userAuditOutcome) {
            <span>Yes</span>
          }
          @if (!capture.userAuditOutcome) {
            <span>No</span>
          }
        </span>
        <span>
          <strong>Invoiced:</strong>
          @if (!capture.invoicingDuplicate && capture.invoiceDate) {
            <span> Yes, {{ capture.invoiceDate | date: 'MM/yyyy' }} </span>
          }
          @if (!capture.invoicingDuplicate && !capture.invoiceDate) {
            <span> No </span>
          }
          @if (capture.invoicingDuplicate) {
            <span> Duplicate </span>
          }
        </span>
        <span>
          <strong>Credited:</strong>
          @if (!capture.invoicingDuplicate && capture.creditDate) {
            <span> Yes, {{ capture.creditDate | date: 'MM/yyyy' }} </span>
          }
          @if (!capture.invoicingDuplicate && !capture.creditDate) {
            <span> No </span>
          }
          @if (capture.invoicingDuplicate) {
            <span> N/A </span>
          }
        </span>
      </div>
      @if (canSnapshot) {
        <div class="my-1 d-inline-block">
          <app-capture-snapshot [capture]="capture" />
        </div>
      }
      @if (canReprocess) {
        <div class="my-1 d-inline-block">
          <app-capture-reprocess [capture]="capture" />
        </div>
      }
      @if (canUnverify) {
        <div class="my-1 d-inline-block">
          <app-capture-unverify [capture]="capture" />
        </div>
      }
      @if (canViewStatusDetailReport) {
        <div class="my-1 d-inline-block">
          <a class="btn btn-secondary" routerLink="/capture-admin/captures/{{capture.id}}/status-detail-report">STATUS DETAIL</a>
        </div>
      }
    </div>
  </div>
  <div class="border py-1 rounded" [ngClass]="{ 'inactive': !capture.client.active }">
    <div class="inactive-label" [ngClass]="{ 'd-none': capture.client.active }">INACTIVE</div>
    <div class="row mx-1">
      <div class="col-auto">
        <strong>CLAIM ID</strong>
        <div>{{ capture.candidate.claimIdentifier }}</div>
      </div>
      <div class="col-auto text-center">
        <strong>CAPTURE ID</strong>
        <div>{{ capture.id }}</div>
      </div>
      <div class="col-auto capture-status">
        <strong>STATUS</strong>
        <div>
          {{ capture.status | captureStatus }}
          @if (capture.statusReason) {
            <span>
              -
            </span>
          }
        </div>
        @if (capture.statusReason) {
          <div>
            <small>
              {{ capture.statusReason | captureStatusReason }}
            </small>
          </div>
        }
      </div>
      <div class="col-auto">
        <div>
          <strong>CLIENT</strong>
          @if (!capture.client.active) {
            <span class="inactive-client">INACTIVE</span>
          }
        </div>
        <app-client-name [client]="capture.client" />
        @if (capture.client.entityTypes) {
          <div>
            Type: {{ capture.client.entityTypes | joinList }}
          </div>
        }
        @if (capture.ehrAccess) {
          <div class="indicator-pill indicator-pill-green indicator-pill-full-width">
            EHR Access
          </div>
        }
        @if (capture.client.outreachAttemptEvidenceEnabled) {
          <div class="indicator-pill indicator-pill-green indicator-pill-full-width">
            Outreach Attempts
          </div>
        }
      </div>
      <div class="col-auto">
        <strong>CE-PATIENT</strong>
        <app-patient-name
          [patient]="capture.patient"
          [sourcePatient]="capture.sourcePatient"
          [canViewPatient]="canViewPatient" />
        @if (showHealthGorillaTag) {
          <span
            class="indicator-pill indicator-pill-green"
            title="HIE Patient Created">
            HIE
          </span>
        }
      </div>
      <div class="col-auto">
        <strong>RX-PATIENT</strong>
        <app-candidate-patient-name [candidate]="capture.candidate" />
      </div>
      <div class="col-auto text-end">
        <strong>EXPIRES ON</strong>
        <div>
          <app-expiration-date [expirationDate]="capture.expirationDate" />
        </div>
      </div>
      <div class="col-auto">
        <strong>EST. VALUE</strong>
        <div>{{ capture.candidate.estimatedValueForDisplay }}</div>
        <app-high-value-indicator [capture]="capture" />
        @if (capture.candidate.estimatedValueMethodDescription) {
          <div class="estimated-value-method">
            <small>
              <strong>
                {{ capture.candidate.estimatedValueMethodDescription }}
              </strong>
            </small>
          </div>
        }
      </div>
      <div class="col-auto">
        <strong>DRUG</strong>
        <app-candidate-drug
          [candidate]="capture.candidate"
          [wrapDrugName]="true"
          [showCopy]="true"
          [displayFlaggedForEsp]="true"
          />
      </div>
      @if (showClientReviewTask) {
        <div class="col-auto">
          <strong>CE TASKS</strong>
          <div>
            <strong>PRESCRIBER: </strong>
            @if (capture.clientPrescriberTask) {
              <span>
                <a routerLink="/capture-admin/referral-claims/clients/client-prescriber-tasks/{{ capture.clientPrescriberTask.id }}"
                  target="_blank">
                  {{ capture.clientPrescriberTask.id }}
                </a>
                ({{ capture.clientPrescriberTask.status | capitalize }})
              </span>
            } @else {
              No
            }
          </div>
          <div>
            <strong>REFERRAL: </strong>
            @if (capture.clientReferralTask) {
              <span>
                <a routerLink="/capture-admin/referral-claims/clients/client-referral-tasks/{{ capture.clientReferralTask.id }}"
                  target="_blank">
                  {{ capture.clientReferralTask.id }}
                </a>
                ({{ capture.clientReferralTask.status | capitalize }})
              </span>
            } @else {
              No
            }
          </div>
          <div>
            <strong>CONSULT NOTE: </strong>
            @if (capture.clientConsultNoteTask) {
              <span>
                <a routerLink="/capture-admin/referral-claims/clients/client-consult-note-tasks/{{ capture.clientConsultNoteTask.id }}"
                  target="_blank">
                  {{ capture.clientConsultNoteTask.id }}
                </a>
                ({{ capture.clientConsultNoteTask.status | capitalize }})
              </span>
            } @else {
              No
            }
          </div>
        </div>
      }
      @if (capture.autoRefillSource) {
        <div class="col-auto">
          <strong>AUTO VERIFIED FROM CLAIM</strong>
          <div>
            <a routerLink="/capture-admin/captures/{{capture.autoRefillSource.id}}" target="_blank">{{
              capture.autoRefillSource.candidate.claimIdentifier
            }}</a>
          </div>
        </div>
      }
    </div>
    <div class="row mx-1">
      <div class="col-auto">
        <strong>RX-PRESCRIBER</strong>
        <app-prescriber-name [provider]="capture.provider" [linkToProvider]="true" />
        @if (capture.clientAffiliatedPrescriber) {
          <span class="client-affiliated-prescriber">
            Client Affiliated Prescriber
          </span>
        }
      </div>
      <div class="col-auto provider-specialties">
        <strong>SPECIALTIES</strong>
        <div>{{ capture.provider.displaySpecialty }}</div>
      </div>
      <div class="col-auto">
        <app-prescriber-offices [provider]="capture.provider" [acceptableFaxStatusOnly]="true" />
      </div>
    </div>
  </div>
</div>
<div id="capture_detail_header_hidden"
  [ngClass]="{ collapse: !isHidden }"
  (click)="onShowClick()"
  (keydown.enter)="onShowClick()"
  tabindex="0"
  role="button">
  <div class="border py-1 rounded">
    <div class="row mx-1">
      <div class="col-auto">
        Capture Details are hidden. Needs Patient Match Approval should focus on the possibility of the names matching and not information within the capture.
        <br>
          Click to show capture details
        </div>
      </div>
    </div>
  </div>
